import React from "react";
import Header from "../components/diseases/header/header";
import { Footer } from "../components/footer/footer";
import Items from "../components/diseases/items/items";
import { diseases } from "../data/diseases";

const Diseases = ({ setViewDiagnosis }) => {
  return (
    <div>
      <Header setViewDiagnosis={setViewDiagnosis} />
      <Items list={diseases} link="/diseases" pagination="true" />
      <Footer />
    </div>
  );
};

export default Diseases;
